const isAuthenticated = () => {
    if (localStorage) {
        // console.log('checkExprieDate : ',checkExprieDate())
        if (localStorage.getItem('access_token')) {
            if (checkExprieDate()) {
                return true;
            }
        }
        return false;
    }
}

const removeToken = () => {
    if (localStorage) {
        localStorage.clear();
        return false;
    }
}

const logOut = () => {
    if (localStorage) {
        localStorage.clear();
        return isAuthenticated();
    }
}

const checkExprieDate = () => {
    const payloadBase64 = localStorage.getItem('access_token').split('.')[1];
    // console.log('payloadBase64 : ', payloadBase64);

    function b64ToUtf8(str) {
        return decodeURIComponent(escape(atob(str)));
    }

    const payload = b64ToUtf8(payloadBase64);
    // console.log('payload : ', payload)
    const jsonPayload = JSON.parse(payload)
    // console.log('jsonPayload : ', jsonPayload)

    //  UNIX timestamp Format
    const dateExpTimeStamp = +jsonPayload.exp;

    // check if date exp is > not before now
    // convert dateNow to UNIX timestamp
    const dateNow = Math.floor(Date.now() / 1000);
    //  console.log('now : '+ dateNow + ' exp : ' + dateExpTimeStamp)
    if (dateNow > dateExpTimeStamp) {
        // console.log('already exprie')
        return false
    } else {
        // console.log('not exprie yet');
        return true
    }
}

export { isAuthenticated, removeToken, logOut };